import React from 'react'

export default function SocialTelegramIcon ({ size = 20, color = '#2AABEE', plain = false, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {!plain && <circle cx="10" cy="10" r="10" fill={color} />}
      <path
        d={plain ? 'M17.72 2.35 2.65 8.16c-1.03.41-1.02.98-.19 1.24l3.87 1.21 1.48 4.61c.18.5.09.7.62.7.41 0 .59-.19.81-.41l1.88-1.83 3.91 2.89c.72.4 1.24.19 1.42-.67l2.57-12.11c.26-1.06-.41-1.54-1.3-1.44ZM7.1 10.33l8.7-5.49c.43-.26.82-.12.5.17l-7.18 6.48-.28 3.02-1.74-4.18Z' : 'M14.621 6.022c.197-.067.37.104.314.306l-2.047 7.253c-.052.185-.277.258-.428.138l-3.088-2.443-1.576 1.514c-.161.155-.43.071-.474-.148l-.56-2.779-2.67-.855c-.23-.074-.247-.393-.026-.491l10.555-4.495Zm-1.398 1.739-5.7 2.385.408 1.585.22-1.076 5.072-2.894Z'}
        fill={plain ? color : 'white'}
      />
    </svg>
  )
}
